import React from "react";
import { Input, Select } from "antd";

const { Option } = Select;

// 공통 필터 Select 컴포넌트
export const FilterSelect = ({
  value,
  onChange,
  placeholder,
  options,
  mode = "default",
  showSearch = true,
  style = { width: "100%" },
}) => {
  return (
    <Select
      allowClear={true}
      mode={mode === "multiple" ? "multiple" : undefined}
      style={style}
      showSearch={showSearch}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      filterOption={(input, option) =>
        option.children.toString().toLowerCase().includes(input.toLowerCase())
      }
    >
      {options}
    </Select>
  );
};

// 공통 필터 Input 컴포넌트
export const FilterInput = ({
  value,
  onChange,
  placeholder,
  style = { width: "100%" },
}) => {
  return (
    <Input
      allowClear={true}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={style}
    />
  );
};

// 이진(O/X) 옵션 생성 함수
export const createBinaryOptions = (labelO, labelX) => [
  <Option key="option-o" value="O">
    {labelO || "O"}
  </Option>,
  <Option key="option-x" value="X">
    {labelX || "X"}
  </Option>,
];

// 옵션 생성 헬퍼 함수
export const createOptions = (items, keyPrefix, valueKey, labelKey) => {
  return items.map((item, index) => (
    <Option key={`${keyPrefix}-${index}`} value={item[valueKey]}>
      {item[labelKey] ? item[labelKey] : `invalid ${keyPrefix} name`}
    </Option>
  ));
};
